import React, { useEffect, useState } from 'react';
import { Container, Typography, Card, CardContent, Link } from '@mui/material';
import bibtexParse from 'bibtex-parse-js';
import { formatAuthors } from '../utils';

function Conference() {
    const [papers, setPapers] = useState([]);

    useEffect(() => {
        // BibTeXファイルを読み込む
        fetch(`${process.env.PUBLIC_URL}/conference-papers.bib`)
            .then((response) => response.text())
            .then((data) => {
                const parsed = bibtexParse.toJSON(data);
                setPapers(parsed);
            })
            .catch((error) => console.error('Error loading BibTeX file:', error));
    }, []);

    return (
        <Container>
            {papers.map((paper, index) => (
                <Card
                    key={index}
                    variant="outlined"
                    sx={{
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        padding: '10px',
                    }}
                >
                    <CardContent sx={{ flex: 1 }}>
                        {/* 論文タイトル */}
                        <Typography variant="body1" sx={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            {paper.entryTags.title}
                        </Typography>

                        {/* 著者情報 */}
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {formatAuthors(paper.entryTags.author)}
                        </Typography>

                        {/* イベントタイトル (会議名) */}
                        {paper.entryTags.eventtitle && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {paper.entryTags.eventtitle}
                            </Typography>
                        )}

                        {/* 出版物タイトル (例: Lecture Notes in Computer Science) */}
                        {paper.entryTags.booktitle && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {paper.entryTags.booktitle}
                                {paper.entryTags.volume && `, Vol. ${paper.entryTags.volume}`}
                                {paper.entryTags.pages && `, pp. ${paper.entryTags.pages}`}
                            </Typography>
                        )}

                        {/* 開催地、期間、年 */}
                        <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                            {paper.entryTags.location && `${paper.entryTags.location}, `}
                            {paper.entryTags.dates}
                            {paper.entryTags.year && `, ${paper.entryTags.year}`}
                        </Typography>

                        {/* Paper ID (noteから取得) */}
                        {paper.entryTags.note && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                {paper.entryTags.note}
                            </Typography>
                        )}
                        
                        {/* DOI */}
                        {paper.entryTags.doi && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                DOI: <Link href={`https://doi.org/${paper.entryTags.doi}`} target="_blank" rel="noopener noreferrer">
                                    {paper.entryTags.doi}
                                </Link>
                            </Typography>
                        )}

                        {/* ISBN */}
                        {paper.entryTags.isbn && (
                            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '5px' }}>
                                ISBN: {paper.entryTags.isbn}
                            </Typography>
                        )}
                        
                        {/* 外部リンク */}
                        {paper.entryTags.url && (
                            <Typography variant="body2">
                                <Link href={paper.entryTags.url} target="_blank" rel="noopener noreferrer">
                                    External Link
                                </Link>
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
        </Container>
    );
}

export default Conference;
